import Axios from "axios";
import CryptoJS from "crypto-js";
import secureLocalStorage from "react-secure-storage";

const API_URL = process.env.REACT_APP_API_URL;

const crypto_secret = "secretcodehere";
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));
  post = async (url, data) => {
    const userdata = secureLocalStorage?.getItem("userdata");
    return await this.request(
      this.getOptionsConfig("post", url, {
        ...data,
        attributes: {
          ...data?.attributes,
          loggedIn_u_id: userdata?.u_id,
          u_id: userdata?.u_id,
          u_type: userdata?.u_type,
          parent_u_id: userdata?.parent_u_id,
          admin_u_id:
            userdata?.u_type === 1 ? userdata?.u_id : userdata?.admin_u_id,
        },
      })
    );
  };

  put = async (url, data) =>
    await this.request(this.getOptionsConfig("put", url, data));
  patch = async (url, data) =>
    await this.request(this.getOptionsConfig("patch", url, data));
  delete = async (url) =>
    await this.request(this.getOptionsConfig("delete", url));
  getOptionsConfig = (method, url, og_data) => {
    const access_token = secureLocalStorage.getItem("access_token");
    const enc_data = CryptoJS.AES.encrypt(
      JSON.stringify(og_data),
      crypto_secret
    ).toString();

    const data = {
      access_token: og_data?.access_token,
      data: enc_data,
    };

    return {
      method,
      url,
      data,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
      },
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then(async (res) => {
          const data = await JSON.parse(
            CryptoJS.AES.decrypt(res?.data, crypto_secret).toString(
              CryptoJS.enc.Utf8
            )
          );
          resolve(data);
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }
}
export default new HttpService();
